import { TrendingUp, Minus, AlertTriangle } from "lucide-react";

const MAP = {
  positive: {
    label: "Positive",
    color: "text-[#10b981] border-[#10b981]/30 bg-[#10b981]/10",
    Icon: TrendingUp,
  },
  neutral: {
    label: "Neutral",
    color: "text-[#94a3b8] border-[#334155] bg-[#111827]",
    Icon: Minus,
  },
  cautionary: {
    label: "Cautionary",
    color: "text-[#f43f5e] border-[#f43f5e]/30 bg-[#f43f5e]/10",
    Icon: AlertTriangle,
  },
};

export default function SentimentBadge({ sentiment }) {
  const cfg = MAP[sentiment] || MAP.neutral;
  const Icon = cfg.Icon;
  return (
    <span
      data-testid={`sentiment-${sentiment}`}
      className={`inline-flex items-center gap-1 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${cfg.color}`}
    >
      <Icon className="h-3 w-3" />
      {cfg.label}
    </span>
  );
}
